<template>
  <div>
    <card
      v-if="result.isSuccessful"
      icon="check"
      theme="success"
      title="ecommerce.checkout.complete.successTitle">
      <div v-if="result.isSuccessful" class="success"></div>
      <h6>
        {{ translateUcFirst("ecommerce.checkout.complete.successExplain") }}
      </h6>

      <template #footer>
        <p>
          {{
            translateUcFirst("ecommerce.checkout.complete.resultDataExplain")
          }}
        </p>
        <div class="max-width-300">
          <div
            v-tooltip="{
              content: 'ecommerce.checkout.complete.orderIdTooltip',
            }"
            class="flex flex-between">
            <icon-text icon="cart-basket"
              >{{ translateUcFirst("ecommerce.checkout.complete.orderId") }}:
            </icon-text>
            <strong>{{ order?.id ? order.id : "-" }}</strong>
          </div>
          <div
            v-tooltip="{
              content: 'ecommerce.checkout.complete.paymentIdTooltip',
            }"
            class="flex flex-between">
            <icon-text icon="credit-cards"
              >{{ translateUcFirst("ecommerce.checkout.complete.paymentId") }}:
            </icon-text>
            <strong>{{ payment?.id ? payment?.id : "-" }}</strong>
          </div>
        </div>
      </template>
    </card>

    <card
      v-if="!result.isSuccessful"
      icon="x"
      theme="error"
      title="ecommerce.checkout.complete.errorTitle">
      <div v-if="result.errors.paymentAssignment">
        <p>
          {{
            translateUcFirst(
              "ecommerce.checkout.complete.paymentAssignmentError1"
            )
          }}
        </p>
        <p>
          {{
            translateUcFirst(
              "ecommerce.checkout.complete.paymentAssignmentError2"
            )
          }}
        </p>
      </div>
      <div v-if="result.errors.orderCreation">
        <p>
          {{
            translateUcFirst("ecommerce.checkout.complete.orderCreationError1")
          }}
        </p>
        <p>
          {{
            translateUcFirst("ecommerce.checkout.complete.orderCreationError2")
          }}
        </p>
      </div>

      <template #footer>
        <p>
          {{
            translateUcFirst(
              "ecommerce.checkout.complete.resultDataErrorExplain"
            )
          }}
        </p>

        <div class="max-width-300">
          <div
            v-tooltip="{
              content: 'ecommerce.checkout.complete.orderIdTooltip',
            }"
            class="flex flex-between">
            <icon-text icon="cart-basket"
              >{{ translateUcFirst("ecommerce.checkout.complete.orderId") }}:
            </icon-text>
            <strong>{{ order?.id ? order.id : "-" }}</strong>
          </div>
          <div
            v-tooltip="{
              content: 'ecommerce.checkout.complete.paymentIdTooltip',
            }"
            class="flex flex-between">
            <icon-text icon="credit-cards"
              >{{ translateUcFirst("ecommerce.checkout.complete.paymentId") }}:
            </icon-text>
            <strong>{{ payment?.id ? payment?.id : "-" }}</strong>
          </div>
        </div>
      </template>
    </card>
  </div>
</template>

<script>
export default {
  props: {
    result: {
      type: Object,
      default: () => {},
    },
    cart: {
      type: [Object, Boolean],
      default: false,
    },
    order: {
      type: [Object, Boolean],
      default: false,
    },
    showCart: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
